import { FormControl } from '@angular/forms';


const REGRA_CRIACAO_SENHA = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$^+=!*()@%&.-=/*+;~^´`%¨?]).{8,}$/

export function validatePassword(control: FormControl) {
    if (control.value === null || control.value.length < 8) {
        return null;
    }

    if (control.value.match(REGRA_CRIACAO_SENHA)) {
        return null;
    }

    return { invalidPassword: true };
}



// WEBPACK FOOTER //
// ./src/app/_common/validation/password.validator.ts